module.exports = __webpack_public_path__ + "static/media/img14.1ff711c2.jpg";